import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownLeft } from 'lucide-react';

const DashboardCard = ({
    title,
    percentage,
    comparisonText,
    mainValue,
    icon: Icon,
    onButtonClick,
    buttonText = "Check issue",
    bgColor,
    percentageColor,
  }) => {
    const isNegative = percentage?.includes('-');
    const computedBgColor = bgColor || (isNegative ? 'bg-red-100' : 'bg-green-100');
    const computedTextColor = percentageColor || (isNegative ? 'text-red-700' : 'text-green-800');
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      whileHover={{ scale: 1.01 }}
      transition={{ duration: 0.3 }}
      className="flex flex-col items-center justify-between rounded-2xl shadow-sm bg-white 
                 w-[clamp(180px,15vw,220px)] h-auto p-fluid-2 gap-fluid-1 text-center 
                 border border-gray-200"
    >
      {/* Title */}
      <h2 className="text-black font-roboto font-semibold text-fluid-sm">
        {title}
      </h2>

      {/* Comparison Badge */}
     {/* Left-aligned content */}
     <div className="flex flex-col items-start gap-fluid-1">
        {/* Comparison */}
        <div className={`flex items-center gap-fluid-0.5 ${computedBgColor} px-fluid-1 py-fluid-0.5 rounded-md`}>
          <ArrowDownLeft className={`w-fluid-icon-xs h-fluid-icon-xs ${computedTextColor}`} />
          <span className={`text-fluid-xs font-inter font-medium ${computedTextColor}`}>{percentage}</span>
          <span className="text-black text-fluid-xs font-inter font-medium">{comparisonText}</span>
        </div>

        {/* Icon + Value */}
        <div className="flex items-center gap-fluid-1">
          {Icon && <Icon className="w-fluid-2xl h-fluid-2xl text-black" />}
          <span className="text-black font-bold font-roboto text-fluid-3xl">{mainValue}</span>
        </div>

        {/* Button */}
        <button
        onClick={onButtonClick}
        className="border-2 border-[#EA4335] text-black rounded-full 
                    px-fluid-button-x py-fluid-button-y text-fluid-xs font-roboto font-medium 
                    hover:bg-red-50 transition-colors duration-150"
        >
        {buttonText}
        </button>
      </div>
    </motion.div>
  );
};
export default DashboardCard;
